'use strict';

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _logger = require('common/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var RemoveEnterpriseMember = _react2['default'].createClass({
    displayName: 'RemoveEnterpriseMember',
    getInitialState: function getInitialState() {
        return {
            moveDataToAcct: null
        };
    },
    handleChange: function handleChange(e) {
        this.setState({
            moveDataToAcct: e.target.value
        });
    },
    handleSubmit: function handleSubmit() {
        this.props.member.setProperties({ moveDataToAcct: this.state.moveDataToAcct });
        if (this.props.member.moveDataToAcct) _logger2['default'].track('RemoveEnterpriseMember.transferred');
        this.props.member.remove();
    },
    makeDropdown: function makeDropdown() {
        var _this = this;

        return _react2['default'].createElement(
            'select',
            { onChange: function onChange(e) {
                    return _this.handleChange(e);
                } },
            _react2['default'].createElement(
                'option',
                { value: '' },
                'No transfer'
            ),
            this.props.teamMembers.map(function (member, i) {
                return _this.props.member.guid == member.guid || member.pending ? null : _react2['default'].createElement(
                    'option',
                    { key: i, value: member.guid },
                    member.emailAddress
                );
            })
        );
    },
    makeLabel: function makeLabel() {
        var label = 'Who would you like to receive <span class=\'shortened\'>' + this.props.member.emailAddress + '</span>\'s documents';
        label += this.props.member.hasTeamApiKey ? ' and API key? If they are a member, they will be promoted to developer.' : '?';
        return label;
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            { className: 'l-new-modal remove-enterprise-member' },
            _react2['default'].createElement(
                'div',
                { className: 'l-new-modal--content-wrap' },
                _react2['default'].createElement(
                    'div',
                    { className: 'l-new-modal--title' },
                    'Remove User'
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'l-new-modal--content' },
                    _react2['default'].createElement('label', { dangerouslySetInnerHTML: { __html: this.makeLabel() } }),
                    this.makeDropdown()
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'l-new-modal--actions' },
                    _react2['default'].createElement(_button2['default'], {
                        buttonText: 'Confirm',
                        buttonColor: 'grasshopper',
                        buttonHoverColor: 'ashen',
                        buttonClass: 'm-button-submit close',
                        buttonHoverTextColor: 'white',
                        onClick: this.handleSubmit }),
                    _react2['default'].createElement(_button2['default'], {
                        buttonText: 'Cancel',
                        buttonColor: 'black',
                        buttonClass: 'm-button-submit close' })
                )
            )
        );
    }
});

module.exports = RemoveEnterpriseMember;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/content/team/remove-enterprise-member/index.jsx
 ** module id = 848
 ** module chunks = 0
 **/